const PAGELINKS = {
  SIGNUP_LINK: "/signup",
  SIGNUP_TEXT: "Sign Up",
  LOGIN_LINK: "/login",
  LOGIN_TEXT: "Log In",
  LOGOUT_LINK: "/logout",
  LOGOUT_TEXT: "Log Out",
  ABOUT_US_LINK: "/about-us",
  LOCATION_LINK: "/location",
  CONTACT_US_LINK: "/contact-us",
  TERMS_AND_CONDITIONS_LINK: "/terms-and-conditions",
  FAQ: "/faq",
  PAYMENT: "/payment",
  PROFILE_LINK: "/profile",
};

const FOOTERSECTIONS = {
  FOLLOW_US: "Follow Us",
  CONTACT_US: "Contact Us",
  OUR_LOCATION: "Our Location",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  FAQ: "FAQs",
};

const SHOPDETAILS = {
  MAGNOLIA_CAKE_SHOP_NAME: "Magnolia Cakes & Cupcakes",
  MAGNOLIA_CAKE_GOOGLE_MAPS_LINK: "https://maps.app.goo.gl/idYwJGFTCJ8WejKW6",
};

const SOCIALMEDIAS = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
};

const CAKETYPES = {
  CAKE: "Cake",
  CUPCAKE: "Cupcake",
};

const FLAVSERVLISTTYPE = {
  FLAVOURS: "Flavours",
  FILLINGS: "Fillings",
};

const ERRORMESSAGES = {
  DEFAULT_SIGNUP_ERROR: "Please enter all the fields!",
  TERMS_CONDITIONS_UNCHECKED_ERROR:
    "You must agree to the Terms and Conditions before creating your account.",
};

export {
  PAGELINKS,
  FOOTERSECTIONS,
  SHOPDETAILS,
  SOCIALMEDIAS,
  ERRORMESSAGES,
  FLAVSERVLISTTYPE,
  CAKETYPES,
};
